import { normalize, schema } from 'normalizr';

const savedSearch = new schema.Entity('searches', {}, { idAttribute: 'searchId' });

export default savedSearch;
